module.exports = require("core-js/library/fn/get-iterator");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/get-iterator.js